import React, {useMemo, useState} from "react";
import "./header.css";
import {Link, useLocation, useNavigate} from "react-router-dom";
import UserMenu from "../userMenu/UserMenu";
import DomainMenu from "../domainMenu/DomainMenu";
import LogoDark from "../../assets/images/logo-dark.png";
import useView from "../../hooks/useView";
import {QuestionIcon} from "../../assets/icons/QuestionIcon";
import {SettingsIcon} from "../../assets/icons/SettingsIcon";
import useAppContext from "../../hooks/useAppContext";
import {CloseOutlined, MenuOutlined} from "@ant-design/icons";
import useFlag from "../../hooks/useFlag";

const Header = () => {
    const { pathname } = useLocation();
    const navigate  = useNavigate();
    const { data: { shop, totalUnseenMessages } } = useAppContext();
    const { isFlagOn } = useFlag();
    const isV2Enabled = isFlagOn("v2");
    const selectedRouteClass = (options: string[]): string => options.includes(pathname) ? 'selected' : '';
    const view = useView();
    // if(view === 'platform') return null;
    return (
        <div className={`header-container ${view === 'platform' ? 'platform-header' : ''}`}>
            <div className="fixed-header">
                <div className="left">
                    <div className="logo-container">
                        <Link to={"/"}><img className="logo" alt="Vuelve" src={LogoDark} /></Link>
                    </div>
                    <div className="items">
                        <div className={`item ${selectedRouteClass(['/dashboard'])} ${selectedRouteClass(['/'])}`}>
                            <Link to={"/dashboard"}>Dashboard</Link>
                        </div>
                        <div className={`item ${selectedRouteClass(['/automations'])}`}>
                            <Link to={"/automations"}>Automations</Link>
                        </div>
                        <div className={`header-dropdown item ${selectedRouteClass(['/campaigns','/audience'])}`}>
                            <Link to={"/campaigns"}>Campaigns</Link>
                            <div className="options">
                                <div onClick={() => navigate("/campaigns")} className={`item ${selectedRouteClass(['/campaigns'])}`}><Link to={"/campaigns"}>Campaigns</Link></div>
                                <div onClick={() => navigate("/audience")} className={`item ${selectedRouteClass(['/audience'])}`}><Link to={"/audience"}>Audience</Link></div>
                            </div>
                        </div>
                        {/*{shop.data.platformId === 3 ? <div className={`item widgets ${selectedRouteClass(['/widgets'])}`}>*/}
                        {/*    <Link to={"/widgets"}>Widgets</Link>*/}
                        {/*</div> : null}*/}
                        <div className={`header-dropdown in-mobile item ${selectedRouteClass(['/checkouts','/messages', '/orders', '/reports'])}`}>
                            <Link to={"/checkouts"}>Insights</Link>
                            <div className="options">
                                <div onClick={() => navigate("/checkouts")} className={`item in-mobile ${selectedRouteClass(['/checkouts'])}`}><Link to={"/checkouts"}>Abandoned Checkouts</Link></div>
                                <div onClick={() => navigate("/messages")} className={`item in-mobile ${selectedRouteClass(['/messages'])}`}><Link to={"/messages"}>Messages</Link></div>
                                <div onClick={() => navigate("/orders")} className={`item in-mobile ${selectedRouteClass(['/orders'])}`}><Link to={"/orders"}>Orders</Link></div>
                                <div onClick={() => navigate("/campaigns-insights")} className={`item in-mobile ${selectedRouteClass(['/campaigns-insights'])}`}><Link to={"/campaigns-insights"}>Campaigns</Link></div>
                                <div onClick={() => navigate("/customers")} className={`item ${selectedRouteClass(['/customers'])}`}><Link to={"/customers"}>Customers</Link></div>
                                <div onClick={() => navigate("/reports")} className={`item ${selectedRouteClass(['/reports'])}`}><Link to={"/reports"}>Reports</Link></div>
                            </div>
                        </div>
                        <div className={`item in-mobile chat ${selectedRouteClass(['/conversations'])} ${totalUnseenMessages ? 'with-badge' : ''}`}>
                            {totalUnseenMessages ? <div className="badge">{totalUnseenMessages}</div> : null}
                            <Link to={"/conversations"}>Chat</Link>
                        </div>
                        <div className={`item in-mobile chat vivo-ref ${selectedRouteClass(['/vivo'])} ${totalUnseenMessages ? 'with-badge' : ''}`}>
                            <Link to={"/vivo"}>Vivo AI</Link>
                        </div>
                    </div>
                </div>
                <div className="right">
                    <div className="items">
                        {/*<div className={`item chat ${selectedRouteClass(['/conversations'])}`}>*/}
                        {/*    {totalUnseenMessages ? <div className="badge">{totalUnseenMessages}</div> : null}*/}
                        {/*    <Link to={"/conversations"}><ChatFullIcon width={18} color='#fff' /></Link>*/}
                        {/*</div>*/}
                        <div className="right-items">
                            <div className={`item settings ${selectedRouteClass(['/settings'])}`}>
                                <Link to={"/settings"}><SettingsIcon width={16} color='#fff' /></Link>
                            </div>
                            <div className={`item docs ${selectedRouteClass(['/docs'])}`}>
                                <Link to={"/docs"}><QuestionIcon width={18} color='#fff' /></Link>
                            </div>
                        </div>
                    </div>
                    <UserMenu />
                    <DomainMenu />
                </div>
            </div>
        </div>
    )
}

export default Header;
